module.exports = __webpack_public_path__ + "img/peki.c7a667f9.jpg";